import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, throwError, Observable, tap, map } from 'rxjs';
import { environment } from 'src/environments/environment.prod'
import { Firestore, doc, docData } from '@angular/fire/firestore';
export interface Language {
  img: string;
  code: string;
  name: string;
  action: boolean;
  charter: string;
  default: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class AppService {

  private firestore = inject(Firestore);

  public isApp = false

  public open(): void {
    this.isApp = true
  }

  public close(): void {
    this.isApp = false
  }

  create(data: any){
    return this.http.post(environment.apiUrl + 'auth/create/app', data)
  }

  checkPay(id: number){
    return this.http.get(environment.apiUrl + 'auth/check/app/' + id)
  }

  checkDoamin(domain: string){
    return this.http.get(environment.apiUrl + 'auth/check/domain/' + domain)
  }

  pey(data: any){
    return this.http.post(environment.apiUrl + 'auth/pey/app', data)
  }

  show(id: string){
    return this.http.get(environment.apiUrl + 'auth/show/apps/' + id)
  }



  // ყველა ენების გამოტანა
  showLanguages() {
    console.log('[AppService] showLanguages called');
  return this.http.get('https://menuload.com/api/show/app/languages').pipe(
    tap(res => console.log('[AppService] Received languages:', res)),
    catchError(err => {
      console.error('[AppService] Error loading languages:', err);
      return throwError(() => err);
    })
  );
  }

  

  // მომხმარებლის შერჩეული ენების გამოტანა
  getActiveLanguages(appId: string, userId: string): Observable<any> {
    const document = doc(this.firestore, `Users/${userId}/Apps/${appId}`);
    return docData(document, { idField: 'id' });
  }
  
  getInfo(appId: string, userId: string): Observable<any> {
    const document = doc(this.firestore, `Users/${userId}/Apps/${appId}`);
    return docData(document, { idField: 'id' });
  }

  // მომხმარებელმა შეინახოს ენები
  saveLanguages(data: any){
    return this.http.post(environment.apiUrl + 'auth/save/app/languages', data)
  }

  delete(data: any) {
    return this.http.post(environment.apiUrl + "auth/delete/app", data);
  }

  createQr(domain: string){
    return this.http.post(environment.apiUrl + "auth/create/qr", {'domain': domain});
  }

  save(id: number, data: any){
    return this.http.post(environment.apiUrl + "auth/save/app/" + id, data);
  }

  setApp(data: any){
    return this.http.post(environment.apiUrl + "auth/set/app", data);
  }

  // აპლიკაციის ინფორმაციის შენახვა
  updateAbout(data: any){
    return this.http.post(environment.apiUrl + "auth/save/app/info", data);
  }



  uploadLogo(file: File, data: any): Observable<any> {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('appId', data?.appId);
    formData.append('userId', data?.userId);
    return this.http.post(environment.apiUrl  + "auth/upload/logo/", formData).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    // Handle the error here
    return throwError(error.message || 'Server Error');
  }


  
  checkAppOneAuth(id: number){
    return this.http.get(environment.apiUrl + 'auth/check/app/user/' + id)
  }



  constructor(private http: HttpClient) { }
}
